import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=3a5f816d"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports